export enum serverList {
  RICK_MORTY = "rick-morty",
  COUNTRIES = "countries",
}
